'use strict';

angular.module('inara').factory('DeviceWifi', DeviceWifi);

var log = require('../../log/Log').channel('DeviceWifi');

// Promise-oriented wrappers for Cordova WifiWizard plugin functions

DeviceWifi.$inject = ['$q'];

function DeviceWifi($q) {
    /* global WifiWizard */

    return {
        isWifiEnabled: function() {
            return $q(function(resolve, reject) {
                WifiWizard.isWifiEnabled(
                    function(wifiEnabled) {
                        log.debug('isWifiEnabled: ' + wifiEnabled);
                        resolve(wifiEnabled);
                    },
                    function(reason) {
                       log.debug('isWifiEnabled failed: ' + reason); 
                       reject(reason);
                    }
                );
            });
        },

        getCurrentSSID: function() {
            return $q(function(resolve, reject) {
               WifiWizard.getCurrentSSID(
                    function(SSID) {
                        log.debug('getCurrentSSID: ' + SSID);
                        resolve(SSID);
                    },
                    function(reason) {
                        log.debug('getCurrentSSID failed: ' + reason);
                        reject(reason);
                    }
                );
            });
        },

        removeNetwork: function(SSID) {
            return $q(function(resolve, reject) {
                WifiWizard.removeNetwork(
                    SSID, 
                    function() {
                        log.debug('removeNetwork: ' + SSID);
                        resolve();
                    },
                    function(reason) {
                        log.debug('removeNetwork ' + SSID + ' failed: ' + 
                                  reason);
                        reject(reason);
                    }
                );
            });
        },

        setWifiEnabled: function(enable) {
            return $q(function(resolve, reject) {
                WifiWizard.setWifiEnabled(
                    enable, 
                    function() {
                        log.debug('setWifiEnabled: ' + enable);
                        resolve();
                    }, 
                    function(reason) {
                        log.error('setWifiEnabled ' + enable + ' failed: ' + 
                                  reason);
                        reject();
                    }
                );
            });
        },

        addNetwork: function(network, username, password) {
            // TODO: add username as a parameter once WPA Enterprise is supported
            var algorithm = getAlgorithm(network);
            var config = WifiWizard.formatWifiConfig(network.SSID, password, algorithm);
            return $q(function(resolve, reject) {
                WifiWizard.addNetwork(
                    config, 
                    function() {
                        log.debug('addNetwork: ' + network.SSID);
                        resolve();
                    },
                    function(reason) {
                        log.debug('addNetwork ' + network.SSID + ' failed: ' + 
                                  reason);
                        reject(reason);
                    }
                );
            });
        },

        connectNetwork: function(SSID) {
            return $q(function(resolve, reject) {
                WifiWizard.connectNetwork(
                    SSID, 
                    function() {
                        log.debug('connectNetwork: ' + SSID);
                        resolve();
                    }, 
                    function(reason) {
                        log.debug('connectNetwork ' + SSID + ' failed: ' + 
                                  reason);
                        reject(reason);
                    }
                );
            });
        },

        disconnectNetwork: function(SSID) {
            return $q(function(resolve, reject) {
                WifiWizard.disconnectNetwork(
                    SSID, 
                    function() {
                        log.debug('disconnectNetwork: ' + SSID);
                        resolve();
                    }, 
                    function(reason) {
                        log.debug('disconnectNetwork ' + SSID + ' failed: ' + 
                                  reason);
                        reject(reason);
                    }
                );
            });
        },

        startScan: function() {
            return $q(function(resolve, reject) {
                WifiWizard.startScan(
                    function() {
                        log.debug('startScan succeeded');
                        resolve();
                    },
                    function(reason) {
                        log.debug('startScan failed: ' + reason);
                        reject(reason);
                    }
                );
            });
        },

        getScanResults: function(options) {
            return $q(function(resolve, reject) {
                WifiWizard.getScanResults(
                    options, 
                    function(networks) {
                        networks.sort(function(a, b) {
                            if (a.level > b.level) return -1;
                            if (a.level < b.level) return 1;
                            return 0;
                        });
                        log.debug('getScanResults succeeded, network count: ' + 
                                  networks.length);
                        for (var i = 0; i < networks.length; i++) {
                            log.debug(JSON.stringify(networks[i], 4));
                        }
                        resolve(networks);
                    }, 
                    function(reason) {
                        log.debug('getScanResults failed: ' + reason);
                        reject(reason);
                    }
                );
            });
        }
    };

    function getAlgorithm(network) {
        var algorithm = null;
        if (angular.isDefined(network) &&
            network !== null &&
            network.hasOwnProperty('capabilities')) {
            var capabilities = /\[(.*?)\]/g;
            var matches = network.capabilities.match(capabilities);
            for (var i = 0; i < matches.length; i++) {
                var cap = matches[i].toUpperCase();
                if (cap.startsWith('[WPA-PSK') ||
                    cap.startsWith('[WPA2-PSK')) {
                    algorithm = 'WPA';
                } 
            }
        }
        return algorithm;
    }
}

module.exports = DeviceWifi;
